<template>
  <div class="bg-primary tab-header">
    <h5 class="p-3 bg-primary my-auto"> {{title}}</h5>
    <div class="pr-5 pd-0 col-sm-6 search">
      <h5 v-if="isSuperAdmin" class="p-3 col-sm-3 bg-primary my-auto"> {{ $t('USERS.ACCOUNT') }} </h5>
      <b-input-group class="p-2 col-sm-3 input-group"  v-if="isSuperAdmin">
        <b-form-select class="selectbox" :plain="true"
                       :options="accounts"
                       v-model="selectedAccount"
                       @input="filterByAccount">
        </b-form-select>
      </b-input-group>
      <h5 class="p-3 col-sm-2 bg-primary my-auto"> {{ $t('USERS.ROLE') }} </h5>
      <b-input-group class="p-2 col-sm-4 input-group">
        <b-form-select class="selectbox" :plain="true"
                       :options="roles"
                       v-model="selectedRole"
                       @input="filterByRole">
        </b-form-select>
      </b-input-group>
    </div>
    <div class="p-3 pr-5 pd-0 col-lg-3 search">
      <div class="search-icon"><i class="fa fa-search"></i></div>
        <b-input-group>
          <b-form-input class="search-text" @input="emitInput" :placeholder="$t('WORKFLOW.SEARCH')" ref="searchInput"/>
          <div v-show="showClear" class="clear-btn" @click="clearFilter" v-html="svg.broom"></div>
        </b-input-group>

    </div>
  </div>
</template>

<script>
import svg from '../../_svg.js'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      selectedRole: null,
      selectedAccount: null,
      svg: svg,
      showClear: false
    }
  },
  props: {
    title: String,
    roles: Array,
    accounts: Array
  },
  computed: {
    ...mapGetters(['isAdmin', 'isSuperAdmin', 'accountId'])
  },
  created () {
    if (this.isSuperAdmin) {
      this.selectedAccount = -1
      this.selectedRole = 2
    } else if (this.isAdmin) {
      this.selectedAccount = this.accountId
      this.selectedRole = -1
    }
  },
  methods: {
    filterByRole () {
      this.$emit('filterByRole', this.selectedAccount, this.selectedRole)
    },
    filterByAccount () {
      this.selectedRole = (this.selectedAccount === -1) ? 2 : -1
      this.$emit('filterByAccount', this.selectedAccount, this.selectedRole)
    },
    emitInput (input) {
      this.$emit('filterInput', input)
      if (input !== '') this.showClear = true
      else this.showClear = false
    },
    clearFilter () {
      this.$refs.searchInput.$el.value = ''
      this.emitInput('')
      this.showClear = false
    }
  }
}
</script>

<style lang="scss" scoped>
 .search {
    display: flex;
    justify-content: flex-end;

    .search-text {
      border-radius: 20px;
      padding: 8px 15px;
      border-color: #939dad ;
    }


    .clear-btn {
      font-size: 1.3rem;
      padding: 5px 0px;
      cursor: pointer;
      z-index: 10;
      right: 1rem;
      position: absolute;

    }

    .search-icon {
      font-size: 1.3rem;
      padding: 6px 10px;
    }
  }


  .tab-header h5{
    text-transform: uppercase;
  }

  .tab-header{
    display: flex;
    justify-content: space-between;
  }
  .select_type1{
    margin-right: 10px;
    margin-top: 12px;
  }
  .select_type2{
  margin-left: 10px;
    margin-top: 12px;
  }
  .selectbox{
    width: auto;
    margin-top: 12px;
    height: auto;
    border-radius: 8px;
  }

  .search_filter {
    margin: 0px 2px 3px 2px;
  }

  .input-group {
    max-width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/utils/UsersSearchBar.vue